import { t } from '@lingui/core/macro';
import { BooleanFilter } from './BooleanFilter';
export const materialAgreementFilterLabel = () => t({ message: 'Material Agreement', comment: 'Insights: Material Agreement filter' });
export function MaterialAgreementFilter() {
    return <BooleanFilter name="metadataDocumentMaterialAgreement" label={materialAgreementFilterLabel()}/>;
}
